
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { findIndex } from "lodash";
import { MatTooltipModule } from '@angular/material/tooltip';
import { Tag } from '@teammood/shared/ui/tags-input';
import { RemoveNonAlphanumericModule } from '../../shared/util/remove-non-alphanumeric';
import { Subject } from 'rxjs';
import { CalendarFilterServiceProps } from '../calendar.type';

@Component({
    selector: 'mood-filters',
    templateUrl: './mood-filters.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatTooltipModule,
    RemoveNonAlphanumericModule
]
})
export class MoodFiltersComponent implements OnInit, OnDestroy {

    @Input() tags: Tag[] = [];

    @Input()
    calendarFilterServiceProps: CalendarFilterServiceProps;

    @Output()
    protected onCallingService: EventEmitter<CalendarFilterServiceProps> = new EventEmitter<CalendarFilterServiceProps>()

    protected teamId: string;
    selectedCombinator: string;
    combinationPanelIsSet: boolean;
    selected_tags: any[];
    tag_disabled: string;

    private _destroy$ = new Subject<void>();

    constructor() {}

    ngOnInit() {
        this.combinationPanelIsSet = false;

        this.teamId = this.calendarFilterServiceProps?.teamId;
        this.selectedCombinator = this.calendarFilterServiceProps?.selectedCombinator;
        this.selected_tags = this.calendarFilterServiceProps?.selected_tags;

    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    tagIsActive (tag) {
        return tag.isSelected
            || (this.selectedCombinator === "any" && tag.isEligibleAny)
            || (this.selectedCombinator === "all" && tag.isEligibleAll)
    };

    allSelectorIsActive () {
        if (this.selected_tags) {
            const eligibleSelectedTagsCount = this.selected_tags.filter(tag => tag.isEligibleAll).length;
            const selectedTagsCount = this.selected_tags.length;
            return eligibleSelectedTagsCount === selectedTagsCount;
        } else
            return true;
    };

    anySelectorIsActive () {
        if (this.selected_tags) {
            const eligibleSelectedTagsCount = this.selected_tags.filter(tag => tag.isEligibleAny).length;
            const selectedTagsCount = this.selected_tags.length;
            return eligibleSelectedTagsCount === selectedTagsCount;
        } else
            return true;
    };

    isThereATagFollowing (index, length) {
        return index + 1 < length;
    };

    call_service(teamId: string, selectedCombinator: string, selected_tags: Tag[]) {
        if (!this.combinationPanelIsSet) {
            this.combinationPanelIsSet = true;
        }

        this.onCallingService.emit({
            teamId: teamId,
            selectedCombinator: selectedCombinator,
            selected_tags: selected_tags
        });
    }

    changedCombinator () {
        this.call_service(this.teamId, this.selectedCombinator, this.selected_tags);
    };

    updateTags (tag) {
        const position = findIndex(this.selected_tags, function (t: any) {
            return t.name === tag.name;
        });
        if (position !== -1) {
            this.selected_tags.splice(position, 1);
        } else {
            this.selected_tags.push(tag);
        }

        this.call_service(this.teamId, this.selectedCombinator, this.selected_tags)
    };

}

